export const EPSG3857 = {
  name: "EPSG:3857",
  proj4: "",
  wkt: "WGS_1984_Web_Mercator_Auxiliary_Sphere",
}